import { DeepPartial } from 'utility-types';
import {
  Record,
  String as RTString,
  Array as RTArray,
  Number as RTNumber,
  Undefined,
  Static,
  Null
} from 'runtypes';
import { ExistingAccount, Investment } from '../investment';
import { Address } from '../address';
import { Phone } from '../phone';

export const IndividualBeneficiary = Record({
  taxID: RTString.Or(Undefined).Or(Null),
  percentage: RTNumber,
  beneficiaryType: RTString,
  name: Record({
    firstName: RTString,
    middleName: RTString.Or(Undefined).Or(Null),
    lastName: RTString
  }),
  dateOfBirth: RTString.Or(Undefined).Or(Null),
  relationship: RTString
});

export const EntityBeneficiary = Record({
  taxID: RTString.Or(Undefined).Or(Null),
  percentage: RTNumber,
  beneficiaryType: RTString,
  name: RTString
});

export const OCRPrimaryCustomer = Record({
  name: Record({
    firstName: RTString,
    middleName: RTString.Or(Undefined),
    lastName: RTString
  }),
  citizenship: RTString,
  dob: RTString,
  taxID: RTString,
  taxIDType: RTString,
  residentialAddress: Address,
  mailingAddress: Address,
  primaryEmailAddress: RTString,
  phones: RTArray(Phone),
  businessPartyId: RTNumber
});

export const OCRApplication = Record({
  customer: OCRPrimaryCustomer,
  beneficiaries: Record({
    individuals: RTArray(IndividualBeneficiary),
    entities: RTArray(EntityBeneficiary)
  }).Or(Undefined),
  existingAccounts: RTArray(ExistingAccount).Or(RTArray(Record({}))),
  newInvestments: RTArray(Investment),
  estimatedRolloverAmount: RTNumber,
  investmentMethod: RTString,
  rolloverType: RTString
});
export type StaticOCRApplication = Static<typeof OCRApplication>;
export type OptionalOCRApplication = DeepPartial<StaticOCRApplication>;
